import { render, staticRenderFns } from "./VehicleMaintenance.vue?vue&type=template&id=397383ab"
import script from "./VehicleMaintenance.vue?vue&type=script&lang=js"
export * from "./VehicleMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports